import { Component, Renderer2, ViewChild, OnInit, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PtImageMappingService } from '../../../service/pt-image-mapping.service';
import { SpecimenPreviewService } from '../../../service/specimen-preview.service';
import { ConstantService } from '../../../service/constant.service';
import { ObervableService } from '../../../service/obervable.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { AddImageDailogComponent } from './../dailog/specimen/add-image-dailog/add-image-dailog.component';
import { SCopyImageComponent } from './../dailog/specimen/s-copy-image/s-copy-image.component';
import { AddImageErrorComponent } from './../dailog/specimen/add-image-error/add-image-error.component';
import { RemoveImageComponent } from '../dailog/specimen/remove-image/remove-image.component';
import { ImageLogComponent } from '../dailog/specimen/image-log/image-log.component';
import { AppConfigService } from 'app-config';

@Component({
	selector: 'app-specimen-based',
	templateUrl: './specimen-based.component.html',
	styleUrls: ['./specimen-based.component.scss']
})
export class SpecimenBasedComponent implements OnInit {

	@ViewChild(MatPaginator) paginator: MatPaginator;

	public staffURL = AppConfigService.settings.apiServer.staffHome;
	public mailingID: string = null;
	public displayedColumns: string[] = ['specimenCode', 'group', 'sequence', 'thumbnailView', 'externalName', 'name', 'imageNumber', 'action'];
	public dataSource = new MatTableDataSource([]);
	public isDataSourceBlack: boolean = false;
	public pageSizeOptions = [];
	public pageSize;
	public showTotalPages = 10;
	public specimenList: Array<object> = [];
	public productList: Array<object> = [];
	public mailingYears: Array<object> = [];
	public mappedImages: Array<object> = [];
	public selectedSpecimenValue: string = '';
	public selectedProductValue: string = '';
	public selectedYearValue: string = "";
	public selectedMappedMailingValue: string = "";
	public imageTypes: Array<object> = [];
	public preSelectYear: string = '';
	public copyImageSuccess: any = null;
	public addedImageObject: any = {
		imageNumber: '',
		preSignedUrlForImageUpload: '',
		approved_show: false
	};
	public alertSuccessMessage: string = null;
	public isCopy: boolean = true;

	@ViewChild('lightbox') lightbox = null;
	public lightBoxImagePath: any = '';

	private obervableService: ObervableService;
	private specimenPreviewService: SpecimenPreviewService;
	private constantService: ConstantService;
	private ptImageMappingService: PtImageMappingService;

	constructor(
		public dialog: MatDialog,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private injector: Injector,
		private renderer: Renderer2
	) {

		this.obervableService = this.injector.get<ObervableService>(ObervableService);
		this.specimenPreviewService = this.injector.get<SpecimenPreviewService>(SpecimenPreviewService);
		this.constantService = this.injector.get<ConstantService>(ConstantService);
		this.ptImageMappingService = this.injector.get<PtImageMappingService>(PtImageMappingService);

		if(this.constantService.getCommitteeMemberPermision()){
			this.router.navigateByUrl('/unauthorized');
		}

		//  GET DYNAMIC MAILING ID FROM PARAM.
		this.activatedRoute.params.subscribe(param => {
			this.mailingID = param.mailingID;
			this.getSpecimenData(param.mailingID, 'specimens');
			this.getSpecimenData(param.mailingID, 'products');
			this.getMappedImageFunction(param.mailingID);
			this.getDefaultYear();
		});
	}

	ngOnInit(): void {
		// GET LOCAL STORAGE YEAR AND POPULATE THE YERA MAILING DROPDOWN.
		this.selectedYearValue = localStorage.getItem('specimen-year');

		this.preSelectYear =  JSON.parse(JSON.stringify(this.selectedYearValue));

		if (this.selectedYearValue !== null) {
			this.getMappedImagesOnYear();
			this.selectedMappedMailingValue = this.mailingID;
		}
	}
	// FETCH YEAR AND POPULATE YEAR DROPDOWN.
	getDefaultYear = () => {
		this.ptImageMappingService.getMailingYears().subscribe((result) => {
			this.mailingYears = result.sort((val: any, val1: any) => val.year - val1.year);
		});
	}

	// RESET SEARCH FORM.
	onClickReset = () => {
		const resetData = JSON.parse(localStorage.getItem('resetSearch'));
		if (resetData && resetData.year && resetData.mailingID) {
			this.router.navigateByUrl('mailing/' + resetData.mailingID + '/images');
			this.selectedYearValue = resetData.year;
			this.selectedMappedMailingValue = resetData.mailingID;
			localStorage.setItem('specimen-year', resetData.year);
		} else {
			this.selectedYearValue = '';
			this.selectedMappedMailingValue = '';
		}

	}

	// FETCHING SPECIMEN DATA AND POPULATE LIST BASED ON YEAR.
	getSpecimenData = (ID, slug) => {
		this.ptImageMappingService.specimenMailingData(ID, slug).subscribe(result => {
			if (slug === 'specimens') {
				this.specimenList = result;
			}
			if (slug === 'products') {
				this.productList = result;
			}
		});
	}

	// FETCHING MAPPED IMAGES BASED ON MAILING ID.
	getMappedImageFunction = (mailingID) => {
		this.ptImageMappingService.mailingSearchResult(mailingID).subscribe(result => {
			const approveFlag = result.filter(item => item.approveFlag === 'N');
			this.addedImageObject.approved_show = (approveFlag.length > 0) ? true : false;

			// MODIFIED RESULT BASED ON RESULT KEYS : BEGIN
			const modifiedResult = [];
			const uniqueResult = [];

			// CREATE AN ARRAY BASED ON RESULT KEYS FOR CHECK DUPLICATES ROWS.
			result.forEach((item: any) => {
				modifiedResult.push({
					diagnosisMenu: item.diagnosisMenu,
					sequence: item.sequence,
					externalName: item.externalName,
					name: item.name,
					typeDesc: item.typeDesc,
					subTypeDesc: item.subTypeDesc,
					imageNumber: item.imageNumber
				});
			});

			// TO CHECK DUPLICATE ROWS AND PUSH ITEM IN UNIQUE ROW ARRAY.
			modifiedResult.forEach((thing, index) => {
				const _thing = JSON.stringify(thing);
				const resIndex = modifiedResult.findIndex(obj => {
					return JSON.stringify(obj) === _thing;
				});
				if (index === resIndex) {
					uniqueResult.push(result[index]);
					return resIndex;
				}
			});
			// MODIFIED RESULT BASED ON RESULT KEYS :END
			// PREPARE TABLE LIST.
			this.prepareDataTable(uniqueResult);
		});
	}

	// ON CHANGE EVENT : SPECIMEN DROPDOWN
	onSpecimenChange = event => {
		this.selectedSpecimenValue = event.target.value;
		this.getDataBasedOnSpecimenAndProduct();
	}

	// ON CHANGE EVENT : PRODUCT DROPDOWN
	onProductChange = event => {
		this.selectedProductValue = event.target.value;
		this.getDataBasedOnSpecimenAndProduct();
	}

	// COMMON FECHING DATA FUNCTION ON PRODUCT AND SPECIMEN DROPDOWN CHANGE.
	getDataBasedOnSpecimenAndProduct = () => {
		const slug = `images?specimen=${this.selectedSpecimenValue}&product=${this.selectedProductValue}`;
		this.ptImageMappingService.specimenMailingData(this.mailingID, slug).subscribe(result => {
			this.prepareDataTable(result);
		});
	}

	// GET MAPPED IMAGES BASED ON YEAR.
	getMappedImagesOnYear = () => {
		this.ptImageMappingService.getMappedImages(this.selectedYearValue).subscribe((result) => {
			this.mappedImages = result;
		});
	}

	// ON CHANGE EVENT : YEAR DROPDOWN
	onYearChange = event => {
		this.selectedYearValue = event.target.value;
		localStorage.setItem('specimen-year', this.selectedYearValue);
		this.getMappedImagesOnYear();
	}

	// ON CHANGE EVENT : MAPPED MAILING DROPDOWN
	onMappedMailingChage = (event) => {
		if (event.target.value !== '') {
			this.router.routeReuseStrategy.shouldReuseRoute = function () {
				return false;
			}
			this.router.onSameUrlNavigation = 'reload';
			this.router.navigateByUrl('mailing/' + event.target.value + '/images');
		}
	}

	// COPY IMAGE - POPUP WINDOW
	copyImage = event => {
		const dailogRef = this.dialog.open(SCopyImageComponent, { data: { rows: this.dataSource.data, mailingID: this.mailingID } });
		dailogRef.afterClosed().subscribe(result => {
			if (result.success) {
				this.copyImageSuccess = {
					noOfImages: result.data.selectedSpecimen.length,
					mailingID: result.data.toMailingU
				}
			}
		});
	}

	// ADD IMAGE - POPUP WINDOW
	onClickAdd = row => {
		let rows: any = {};
		if (!row) {
			const { mailing } = this.dataSource.data[0];
			rows.mailing = mailing;
			rows.mailingID = this.mailingID;
			rows.specimenCode = '';
		} else {
			rows = row;
			rows.is_edit = false;
			rows.mailingID = this.mailingID;
		}
		const dailogRef = this.dialog.open(AddImageDailogComponent, { data: rows });
		dailogRef.beforeClosed().subscribe(addData => {
			if (addData) {
				this.addedImageObject.imageNumber = addData.imageNumber;
				this.addedImageObject.preSignedUrlForImageUpload = addData.preSignedUrlForImageUpload;
				this.addedImageObject.approved_show = true;
				this.addedImageObject.specimenCode = addData.specimenCode;
				this.getMappedImageFunction(this.mailingID);
				const msg = `<b>${addData.name}</b> have been successfully mapped to <b>${addData.code}</b>. Approve to complete image mapping.`;
				this.setSuccessMessage(msg);
			}
		});
	}

	// EDIT IMAGE - POPUP WINDOW
	onClickEdit = row => {
		if (row.name) {
			row.is_edit = true;
			const dailogRef = this.dialog.open(AddImageDailogComponent, { data: row });
			dailogRef.beforeClosed().subscribe(updateData => {
				if (updateData) {
					this.getMappedImageFunction(this.mailingID)
					const msg = `Edit have been successfully saved for <b>${row.name}</b>`;
					this.setSuccessMessage(msg);
				}
			});
		}
	}

	// HISTORY IMAGE - POPUP WINDOW
	onClickHistory = row => {
		if (row.name) {
			this.dialog.open(ImageLogComponent, { data: { row: row, mailingID: this.mailingID } });
		}
	}

	// DELETE IMAGE - POPUP WINDOW
	onClickDelete = row => {
		if (row.name) {
			row.mailingID = this.mailingID;
			const dailogRef = this.dialog.open(RemoveImageComponent, { data: row });
			dailogRef.beforeClosed().subscribe(deleteData => {
				if (deleteData) {
					this.ptImageMappingService.deleteImage(deleteData).subscribe(result => {
						this.getMappedImageFunction(this.mailingID);
						const code = (row.specimenCode !== '') ? row.specimenCode : row.mailingID;
						const msg = `<b>${row.name}</b> has been successfully removed from <b>${code}</b>`;
						this.setSuccessMessage(msg);
					});
				}
			});
		}
	}

	// APPROVE BUTTON ON CLICK EVENT AND CALL COMMON FUNCTION TO UPDATE THE DATA.
	onClickApprove = () => {
		const { mailing } = this.dataSource.data.find(item => item.approveFlag === 'N');
		this.saveUpdateApproveImage({ mailing: mailing }, 'approve', 'Add Image');
	}

	// ALERT MESSAGE CLICK EVENT TO REDIRECT TO SPECIMEN PAGE
	onApproveClick = (id) => {
		const year = id.slice(-4);
		localStorage.setItem('resetSearch', JSON.stringify({ "year": year, "mailingID": id }));
		localStorage.setItem('specimen-year', year);
		setTimeout(() => {
			this.router.navigateByUrl(`/mailing/${id}/images`);
		}, 5);
	}

	// SET COMMON ERROR TRY - POPU WINDOW
	errorTryAgainFn = (title, error_type: string = '') => {
		const dailogRef = this.dialog.open(AddImageErrorComponent, { data: { error: error_type, title: title } });
		dailogRef.beforeClosed().subscribe(result => {
			switch (result.error) {
				case 'approve': {
					const { mailing } = this.dataSource.data.find(item => item.imageNumber === this.addedImageObject.imageNumber);
					this.saveUpdateApproveImage({ mailing: mailing }, 'approve', 'Add Image');
					break;
				}
			}
		});
	}

	// COMMON FUNCTION FOR ADD IMAGE, UPDATE IMAGE, APPROVE IMAGE.
	saveUpdateApproveImage = (formdata, url, title) => {
		this.ptImageMappingService.saveUpdateApproveImage(formdata, url).subscribe(result => {
			if (url === 'approve') {
				if (result === true) {
					this.addedImageObject = {
						imageNumber: '',
						preSignedUrlForImageUpload: '',
						approved_show: false
					};
					this.getMappedImageFunction(this.mailingID);
				} else {
					this.errorTryAgainFn(title, 'approve');
				}
			}
		});
	}

	// PREPARE THE DATATABLE LIST.
	prepareDataTable = rows => {

		if (rows.length <= 0) {
			this.isDataSourceBlack = true;
		}

		const array = [];

		rows.forEach(element => {
			let flag = false;
			array.forEach( item => {
				flag = item == element.specimenCode ? true : false;
			});
			if(!flag) array.push(element.specimenCode);
		});

		let sortingRows = [];

		array.forEach(item => {
			let findRows = rows.filter(ele => item === ele.specimenCode);
			if (findRows.length > 1) {
				findRows = findRows.sort((a, b) => {
					return a.sequence - b.sequence
				});
				sortingRows = [...sortingRows, ...findRows];
			} else {
				sortingRows = [...sortingRows, ...findRows];
			}
		});

		this.dataSource = new MatTableDataSource(sortingRows);
		this.dataSource.paginator = this.paginator;
		this.dataSource.paginator._intl.itemsPerPageLabel = '';

		const imageName = this.dataSource.data.filter(item => item.name !== null);
		this.isCopy = (imageName.length > 0) ? true : false;

		this.setPaginator();
		this.obervableService.paginationBehavior(true);
	}

	setPaginator = () => {
		if (window.matchMedia('(max-width: 769px)').matches) {
			const allLength: number = this.dataSource.data.length;
			this.pageSizeOptions = [1, 2, 3, 4, 5, 6, allLength];
			this.pageSize = 1;
			this.showTotalPages = 1;
			this.paginator._changePageSize(1)
		} else {
			const allLength: number = this.dataSource.data.length;
			this.pageSizeOptions = [5, 10, 15, 25, allLength];
			this.pageSize = 10;
			this.showTotalPages = 10;
			this.paginator._changePageSize(10)
		}
	}

	// COMMON FUNCTION TO SHOW THE ALERT SUCCESS MESSAGE.
	setSuccessMessage = msg => {
		this.alertSuccessMessage = `<i class="fa fa-check-circle"></i> ${msg}`;
	}

	// OPEN IMAGE LIGHT BOX TO SHOW THE IMAGE PREVIEW.
	openImageLightBox = (image_name, image_no) => {
		const year = this.preSelectYear;
		const ext = image_name.split('.').pop();
		const URL = 'PTImages/' + year + '/' + image_no + '.' + ext;
		this.specimenPreviewService.getImageS3Url(URL).subscribe(res => {
			if (ext == 'zip') {
				window.open(res, '_blank');
			} else if (ext == 'htm' || ext == 'html') {
				window.open(res, '_blank', 'location=yes,height=450,width=600,scrollbars=yes,status=yes');
			} else {
				this.lightBoxImagePath = res;
				this.renderer.addClass(this.lightbox.nativeElement, 'open');
				this.renderer.addClass(document.body, 'lightbox-open');
			}
		});
	}

	// CLOSE LIGHT BOX TO IMAGE PREVIEW.
	closeImageLightbox() {
		this.renderer.removeClass(this.lightbox.nativeElement, 'open');
		this.renderer.removeClass(document.body, 'lightbox-open');
	}
}